import React, { FC } from 'react';
import { Badge } from '@lithos';

const MaterializationCell: FC<{ materialization: boolean }> = ({ materialization }) => {
  return <Badge size="s" color={materialization ? 'blue' : 'gray'} label={materialization ? 'Enabled' : 'Disabled'} />;
};

export default MaterializationCell;
